<form (ngSubmit)="proceed()" #f="ngForm" class="facebook-fundraiser-summary-dialog" id="facebookFundraiserConfirmationForm">
  <div class="modal-body facebook-fundraiser-confirmation-modal-body pt-md-5 pb-md-5">
    <div class="form-group row mb-0 pt-2 pb-2">

      You are attempting to link the Facebook Fundraiser to the following accounts.
      If either account is incorrect select the logout option, make the changes, return to the LLS account and select the Facebook Fundraiser option.

      <div class="lls-login">
        <span>LLS login :  <strong>{{currentLLSUserLogin}}</strong></span>
        <span><a (click)="changeLLSUser()" class="text-primary">Logout of LLS Account</a></span>
      </div>

      <div class="facebook-login">
        <span>Facebook login : <strong>{{currentFacebookLogin}}</strong></span>
        <span><a (click)="changeFacebookUser()" class="text-primary">Logout of Facebook Account</a></span>
      </div>
        <span class="facebook-fundraiser-confirmation-question">
            Do you want to proceed?
            <span *ngIf="eventService.selectedEvent?.cssClass === 'program-s2'">If so, please check both boxes below.</span>
        </span>

          <div *ngIf="eventService.selectedEvent?.cssClass === 'program-s2'" class="s2_fb_block">
            <div class="s2-fb-flag">
                <label class="container">I am at least 18 years of age and would like to link my LLS fundraising page to my Facebook account
                    <input type="checkbox"
                           name="confirmAtLeast18YearsAgeFlag"
                           id="confirmAtLeast18YearsAgeFlag"
                           required
                           [(ngModel)]="confirmAtLeast18YearsAgeFlag"
                           #confirmAtLeast18YearsAgeFlagControl="ngModel">
                    <span class="checkmark"></span>
                </label>
                <div class="form-control-error"
                     *ngIf="!confirmAtLeast18YearsAgeFlagControl.valid && (confirmAtLeast18YearsAgeFlagControl.touched || state.isSubmitted)">
                    <ul>
                        <li *ngIf="confirmAtLeast18YearsAgeFlagControl?.errors?.required">This option is required.</li>
                    </ul>
                </div>
            </div>
            <div class="s2-fb-flag">
                <label class="container">On behalf of the participant, I authorize linking participants LLS fundraising page to my parents or legal guardians Facebook account
                    <input type="checkbox"
                           name="authorizeLinkingToParentOrLegalGuardiansFBAccountFlag"
                           id="authorizeLinkingToParentOrLegalGuardiansFBAccountFlag"
                           required
                           [(ngModel)]="authorizeLinkingToParentOrLegalGuardiansFBAccountFlag"
                           #authorizeLinkingToParentOrLegalGuardiansFBAccountFlagControl="ngModel">
                    <span class="checkmark"></span>
                </label>
                <div class="form-control-error"
                     *ngIf="!authorizeLinkingToParentOrLegalGuardiansFBAccountFlagControl.valid && (authorizeLinkingToParentOrLegalGuardiansFBAccountFlagControl.touched || state.isSubmitted)">
                    <ul>
                        <li *ngIf="authorizeLinkingToParentOrLegalGuardiansFBAccountFlagControl?.errors?.required">This option is required.</li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
  </div>
  <div class="d-xs-none d-sm-block d-md-block d-lg-block d-xl-block modal-footer facebook-fundraiser-summary-modal-footer">


    <button form="facebookFundraiserConfirmationForm" class="btn btn-primary proceed-btn" [disabled]="checkingPermission">Continue</button>


    <a class="btn btn-outline-primary cancel-btn" (click)="closeModal()">Cancel</a>


  </div>


  <div class="d-xs-block d-sm-none d-md-none d-lg-none d-xl-none modal-footer facebook-fundraiser-summary-modal-footer">


    <a class="btn btn-outline-primary proceed-btn" (click)="closeModal()">Cancel</a>


    <button form="facebookFundraiserConfirmationForm" class="btn btn-primary cancel-btn" [disabled]="checkingPermission">Proceed</button>


  </div>
</form>
